// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605271410/js/" + chunkId + "." + {"44":"8fed88bf","225":"0a535776","481":"67d1f8e1","486":"7c502c36","770":"9a3b23d1"}[chunkId] + ".0.17180170770455883.chunk.js";
};